import { Component, ChangeDetectionStrategy, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'return-button',
    template: '<ng-content></ng-content>',
    styleUrls: ['./return-button.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.ShadowDom,
    standalone: false
})
export class ReturnButtonComponent {

}
